import React, { useEffect, useState } from "react"
import styles from "./index.module.css"
import DataTable from "ui/DataTable"
import { FilePdfOutlined, EllipsisOutlined } from "@ant-design/icons"
import { Button, Dropdown, Menu, Spin, notification } from "antd"
// import { useParams,  } from "react-router-dom"
import { getBookingWaivers, notifyWaiver } from "store/digital-waiver"
import { useDispatch, useSelector } from "react-redux"
import { NotifyModal } from "components/trips/TripsPreview/modal/Notify"
import { DownloadDocumentModal } from "./modal/DownloadDocument"
import { GuardianDetailsModal } from "./modal/GuardianDetailsModal"
import { WaiverDetails } from "../WaiverDetails"
import { useDevice } from "hooks/useDevice"
export const GuestWaiverDetails = ({ uuid }) => {
  // const { id } = useParams()
  const dispatch = useDispatch()
  const { isMobile } = useDevice()
  const { loading: notifyLoading } = useSelector((store) => store?.digitalWaiver.notifyWaiver) || {}
  const { items, loading } = useSelector((store) => store?.digitalWaiver?.bookingWaivers) || {}
  const [sortParams, setSortParams] = useState({})
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isDownloadModalVisible, setIsDownloadModalVisible] = useState(false)
  const [isGuardianDetailsVisible, setIsGuardianDetailsVisible] = useState(false)
  const [isShowGuestDetails, setIsShowGuestDetails] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [recordData, setRecordData] = useState({})

  const showGuestDetails = (record) => {
    setRecordData(record)
    setIsShowGuestDetails(true)
    setIsLoading(true)
  }

  const getDocumentLabel = (record, signedDocuments) => {
    const documents = Array.isArray(record.documents) ? record.documents : []
    const docName = documents[0] || "Document 1.pdf"
    const totalDocuments = record.status === "Unsigned" ? documents.length : signedDocuments?.length || 0
    return totalDocuments > 1 ? `${docName} +${totalDocuments - 1}` : docName
  }

  const renderDocumentCell = (signedDocuments, record) => {
    if (record.status === "Unsigned") {
      return (
        <button className={`mb-xxs ${styles.documentButton}`} onClick={() => showGuestDetails(record)}>
          <FilePdfOutlined className={styles.pdfIcon} />
          {getDocumentLabel(record, signedDocuments)}
        </button>
      )
    }

    if (signedDocuments && signedDocuments.length > 0) {
      return (
        <button className={`mb-xxs ${styles.documentButton}`} onClick={() => showGuestDetails(record)}>
          <FilePdfOutlined className={styles.pdfIcon} />
          {getDocumentLabel(record, signedDocuments)}
        </button>
      )
    }

    return "-"
  }

  const getActionMenuItems = (record) => {
    const isUnsigned = record.status !== "Signed"
    const menuItems = []
    const hasSharedWaiverKey = "shared_waiver_id" in record

    if (isUnsigned && hasSharedWaiverKey) {
      menuItems.push(
        <Menu.Item
          key="notify"
          onClick={() => {
            setRecordData(record)
            setIsModalVisible(true)
          }}
        >
          Notify Guest
        </Menu.Item>
      )
    } else {
      menuItems.push(
        <Menu.Item
          key="download"
          onClick={() => {
            setIsDownloadModalVisible(true)
            setRecordData(record)
          }}
        >
          Download
        </Menu.Item>
      )
    }

    if (parseInt(record.age) < 18) {
      menuItems.push(
        <Menu.Item
          key="guardian-details"
          onClick={() => {
            setRecordData(record)
            setIsGuardianDetailsVisible(true)
          }}
        >
          Guardian Details
        </Menu.Item>
      )
    }

    return menuItems
  }

  const renderActionCell = (record) => (
    <Dropdown overlay={<Menu>{getActionMenuItems(record)}</Menu>} trigger={["click"]}>
      <Button type="text" icon={<EllipsisOutlined className={styles.icon} />} className={styles.actionCell} />
    </Dropdown>
  )

  const columns = [
    {
      title: "Full Name",
      dataIndex: "full_name",
      key: "full_name",
      render: (text, record) => {
        if (!text) return "-"
        return record.type === "Primary Guest" ? `${text} (Primary Guest)` : text
      }
    },
    {
      title: "Guest Email",
      dataIndex: "guest_email",
      key: "guest_email",
      render: (text) => {
        if (!text) return "-"
        const display = text.length > 10 ? text.substring(0, 10) + "..." : text
        return <span title={text}>{display}</span>
      }
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
      render: (text) => {
        if (!text) return "-"
        const display = text.length > 8 ? text.substring(0, 10) + "..." : text
        return <span title={text}>{display}</span>
      }
    },
    {
      title: "Document",
      dataIndex: "signed_documents",
      key: "signed_documents",
      sorter: true,
      sortOrder: sortParams.document === "asc" ? "ascend" : sortParams.document === "desc" ? "descend" : null,
      render: renderDocumentCell
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
      render: (text) => {
        if (!text) return "-"
        return parseInt(text) < 18 ? `${text} (Minor)` : text
      }
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: true,
      sortOrder: sortParams.status === "asc" ? "ascend" : sortParams.status === "desc" ? "descend" : null,
      render: (status) => {
        const statusClass = status === "Signed" ? styles.statusSigned : styles.statusUnsigned
        return <span className={statusClass}>{status || "Unsigned"}</span>
      }
    },
    {
      title: "Action",
      key: "action",
      render: renderActionCell
    }
  ]
  useEffect(() => {
    if (uuid) {
      dispatch(getBookingWaivers(uuid, sortParams))
    }
  }, [uuid, dispatch, sortParams])

  // Transform the API data to match the table structure
  const tableData =
    items?.map((item, index) => ({
      key: item.id || `waiver-${index}`,
      ...item
    })) || []

  const signedCount = items?.filter((item) => item.status === "Signed").length || 0
  const totalCount = items?.length || 0

  // Handle sorting changes
  const handleTableChange = (pagination, filters, sorter) => {
    const newSortParams = { ...sortParams }

    // Clear previous sort for this field if it exists
    delete newSortParams.document
    delete newSortParams.status

    // Add new sort if there's an active sorter
    if (sorter && sorter.field) {
      const sortOrder = sorter.order === "ascend" ? "asc" : sorter.order === "descend" ? "desc" : null
      if (sortOrder) {
        newSortParams[sorter.field] = sortOrder
      }
    }

    setSortParams(newSortParams)
  }

  const handleNotifyGuest = (values) => {
    const payload = {
      notify_by: values.sendMethod
    }
    if (recordData?.shared_waiver_id) {
      payload.shared_waiver_id = recordData.shared_waiver_id
    }
    if (values.sendMethod === "email") {
      payload.email = values.email
    } else {
      payload.phone_number = values.phoneNumber?.fullNumber
    }
    dispatch(notifyWaiver(uuid, payload)).then((res) => {
      notification.success({
        message: "Notification Sent",
        description: res?.message || "Guest has been notified successfully.",
        placement: "topRight"
      })
      setIsModalVisible(false)
      setRecordData({})
      dispatch(getBookingWaivers(uuid))
    })
  }

  return (
    <div className={styles.waiverDetailsContainer}>
      <div className={styles.waiverTableTitle}>
        Guest Waiver Details ({signedCount} out of {totalCount} Signed)
      </div>
      {isMobile ? (
        <div className={styles.mobileCardsContainer}>
          {loading ? (
            <div className={styles.mobileLoadingWrap}>
              <Spin />
            </div>
          ) : tableData.length === 0 ? (
            <div className={styles.mobileEmpty}>No guest waivers found</div>
          ) : (
            tableData.map((record) => {
              const fullName = record.full_name
                ? record.type === "Primary Guest"
                  ? `${record.full_name} (Primary Guest)`
                  : record.full_name
                : "-"
              const age = record.age ? (parseInt(record.age) < 18 ? `${record.age} (Minor)` : record.age) : "-"
              const statusClass = record.status === "Signed" ? styles.statusSigned : styles.statusUnsigned

              return (
                <div key={record.key} className={styles.mobileCard}>
                  <div className={styles.mobileCardHeader}>
                    <div className={styles.mobileCardName}>{fullName}</div>
                    {renderActionCell(record)}
                  </div>
                  <div className={styles.mobileCardBody}>
                    <div className={styles.mobileCardRow}>
                      <span className={styles.mobileCardLabel}>Status</span>
                      <span className={statusClass}>{record.status || "Unsigned"}</span>
                    </div>
                    <div className={styles.mobileCardRow}>
                      <span className={styles.mobileCardLabel}>Guest Email</span>
                      <span className={styles.mobileCardValue}>{record.guest_email || "-"}</span>
                    </div>
                    <div className={styles.mobileCardRow}>
                      <span className={styles.mobileCardLabel}>Phone Number</span>
                      <span className={styles.mobileCardValue}>{record.phone_number || "-"}</span>
                    </div>
                    <div className={styles.mobileCardRow}>
                      <span className={styles.mobileCardLabel}>Age</span>
                      <span className={styles.mobileCardValue}>{age}</span>
                    </div>
                    <div className={styles.mobileCardRow}>
                      <span className={styles.mobileCardLabel}>Document</span>
                      <span className={styles.mobileCardValue}>{renderDocumentCell(record.signed_documents, record)}</span>
                    </div>
                  </div>
                </div>
              )
            })
          )}
        </div>
      ) : (
        <DataTable
          columns={columns}
          dataSource={tableData}
          pagination={false}
          rowKey="key"
          loading={loading}
          onChange={handleTableChange}
          className="overflow-auto"
        />
      )}
      <NotifyModal
        loading={notifyLoading}
        guestData={recordData}
        visible={isModalVisible}
        onClose={() => {
          setIsModalVisible(false)
          setRecordData({})
        }}
        onSend={handleNotifyGuest}
      />
      <DownloadDocumentModal open={isDownloadModalVisible} onCancel={() => setIsDownloadModalVisible(false)} recordData={recordData} />
      <GuardianDetailsModal open={isGuardianDetailsVisible} onCancel={() => setIsGuardianDetailsVisible(false)} record={recordData} />
      {isShowGuestDetails && (
        <WaiverDetails
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          recordData={recordData}
          visible={isShowGuestDetails}
          onCancel={() => setIsShowGuestDetails(false)}
        />
      )}
    </div>
  )
}
